import React, { useId, useState } from "react";
import { Field } from "../Fields";
import PluginDetails from "./PluginDetails";

/** Wybór konfiguracji bez reguł ani opisów konkretnych firm na froncie. */
export default function PluginSelector({ plugins, value, onChange }) {
  const groupId = useId();
  const [search, setSearch] = useState("");
  const query = search.trim().toLocaleLowerCase("pl");
  const selected = plugins.find((item) => item.code === value);
  const matches = plugins.filter((item) =>
    [item.label, item.info?.description, item.info?.audience]
      .join(" ")
      .toLocaleLowerCase("pl")
      .includes(query),
  );
  return (
    <fieldset className="premium-plugin-selector">
      <legend>Konfiguracja dokumentów</legend>
      {plugins.length > 1 && (
        <Field
          label="Szukaj konfiguracji"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
      )}
      <div className="premium-plugin-options">
        {matches.map((item) => (
          <label
            key={item.code}
            className={`premium-plugin-option ${item.code === value ? "selected" : ""}`}
          >
            <input
              className="form-check-input"
              type="radio"
              name={groupId}
              value={item.code}
              checked={item.code === value}
              aria-label={item.label}
              onChange={() => {
                if (item.code !== value) onChange(item);
              }}
            />
            <span>
              <strong>{item.label}</strong>
              <span className="premium-plugin-description">
                {item.info?.description}
              </span>
            </span>
          </label>
        ))}
      </div>
      {!matches.length && (
        <p role="status">Brak konfiguracji pasujących do wyszukiwania.</p>
      )}
      {selected && (
        <section
          className="premium-plugin-summary"
          aria-label={`Szczegóły: ${selected.label}`}
        >
          <p className="premium-plugin-selected">
            Wybrana konfiguracja: <strong>{selected.label}</strong>
          </p>
          <PluginDetails plugin={selected} />
        </section>
      )}
    </fieldset>
  );
}
